import { Page } from '@/core/architecture'

import { ArtistSearchTemplate } from './template'
import { useViewModel } from './viewModel'

export const ArtistSearch: Page = () => {
  const { state, actions } = useViewModel()

  return <ArtistSearchTemplate state={state} />
}
